<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section>
    <div class="container">
        <div class="content-title" style="text-align: center;">
            <h1 style="text-shadow: none; color: #f15a2d;">{{'ops' | translate}}</h1>
        </div>
        <div class="content-body" style="text-align: center;">
            <h2 class="g-color" style="font-size: 200px;font-weight: 600;">404</h2>
            <a routerLink="/home"><button class="btn-m" style="font-size: 20px;"> {{'back' | translate}} </button></a>
        </div>
    </div>
</section>